import script from "./Gartenkultur-CRM.vue?vue&type=script&setup=true&lang=js"
export * from "./Gartenkultur-CRM.vue?vue&type=script&setup=true&lang=js"

import "./Gartenkultur-CRM.vue?vue&type=style&index=0&id=838fc7c6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-838fc7c6"]])

export default __exports__